import React, { useState } from "react";
import "../styles/Rider.css";
import { ReactComponent as AppStore } from '../assets/images/appstore.svg';
import { ReactComponent as PlayStore } from '../assets/images/googleplay.svg';
import { Link } from "react-router-dom";
import { useLanguage } from "../context/LanguageContext";
import "../styles/driver.css";

const Driver = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const { t } = useLanguage();
  const td = t.driver;

  const toggleQuestion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const featureIcons = ["banknote", "speedometer", "wallet"];
  const supportIcons = ["schedule", "settings", "star"];

  return (
    <>
      <div className="full-container">
        {/* Hero */}
        <div className="hero-sec">
          <div className="hero-text">
            <h1>{td.heroTitle}</h1>
            <p>{td.heroSubtitle}</p>
            <a href="https://apps.apple.com/us/app/berymo-driver/id1440035432">
              <button className="ride">{td.signUpToDrive}</button>
            </a>
          </div>
          <div className="all-images">
            <img
              src="/images/driver1.png"
              alt="Hero"
              className="hero-images"
              style={{ marginTop: '70px' }}
            />
          </div>
        </div>

        {/* Why Drive */}
        <div className="berymo-containerss">
          <h2>{td.whyDriveTitle}</h2>
          <p className="berymo-subtextss">{td.whyDriveSubtitle}</p>
          <div className="berymo-gridss">
            {td.features.map((item, i) => (
              <div className="berymo-box" key={i}>
                <img src={`/images/${featureIcons[i]}.png`} alt={featureIcons[i]} className="icon" />
                <h3>{item.title}</h3>
                <p>{item.text}</p>
              </div>
            ))}
          </div>
        </div>

        {/* App section */}
        <div className="work">
          <div className="jerry">
            <h1>{td.appTitle}</h1>
            <p>{td.appSubtitle}</p>
            <div className="stone-btn">
              <a href="https://apps.apple.com/us/app/berymo-driver/id1440035432" target="_blank" rel="noopener noreferrer">
                <AppStore />
              </a>
              <a href="https://play.google.com/store/apps/details?id=com.berymodriver" target="_blank" rel="noopener noreferrer">
                <PlayStore />
              </a>
            </div>
          </div>
          <div className="phone-image">
            <img src="/images/driverapptra.png" alt="phone" />
          </div>
        </div>

        {/* Support */}
        <div className="berymo-container">
          <h2>{td.supportTitle}</h2>
          <p className="berymo-subtext">{td.supportSubtitle}</p>
          <div className="berymo-grid">
            {td.supportFeatures.map((item, i) => (
              <div className="berymo-box" key={i}>
                <img src={`/images/${supportIcons[i]}.png`} alt={supportIcons[i]} className="icon" />
                <h3>{item.title}</h3>
                <p>{item.text}</p>
              </div>
            ))}
          </div>
          <Link to="/safety" className="safety">{td.safetyLink}</Link>
        </div>

        <div>
          <div className="driver-image">
            <img src="/images/driver-overview-general.jpg" alt="driver" />
          </div>
        </div>

        {/* Requirements */}
        <div className="driver-req-section">
          <h2>{td.howToBecomeTitle}</h2>
          <p className="intro-text">{td.howToBecomeIntro}</p>
          <div className="requirement-columns">
            {td.requirements.map((col, i) => (
              <div className="column" key={i}>
                <h3>{col.title}</h3>
                <ul>
                  {col.items.map((item, j) => (
                    <li key={j}>✔ {item}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        {/* FAQ */}
        <div className="faq-sections">
          <h1>{td.faqTitle}</h1>
          <div className="faq-lists">
            {td.faq.map((item, index) => (
              <div key={index} className="faq-items" onClick={() => toggleQuestion(index)}>
                <div className="faq-questions">
                  <span>{item.question}</span>
                  <span className="plus-icon">{activeIndex === index ? "×" : "+"}</span>
                </div>
                <div className={`faq-answers ${activeIndex === index ? "open" : ""}`}>
                  {item.answer}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* CTA */}
        <div className="signup-section">
          <h1>{td.ctaTitle}</h1>
          <p>{td.ctaSubtitle}</p>
          <a href="https://play.google.com/store/apps/details?id=com.berymodriver">
            <button className="ride">{td.signUpToDrive}</button>
          </a>
        </div>
      </div>
    </>
  );
};

export default Driver;
